<div class="flex flex-col h-full">
  <cat-search-map
    #searchMap
    (moveEnd)="onMapChange(searchMap)"
    [disableZoomOut]="true"
    [extent]="searchItem.coordinates"
    [heatmap]="heatmap()"
    [searchItem]="searchItem"
    [zoom]="0.5"
    class="flex-1"
  ></cat-search-map>
  <div class="p-3 flex justify-center">
    <button (click)="onSearch()" id="catalog_facet-map_btn_search" mat-flat-button>
      <mat-icon>search</mat-icon>
      {{ facetItem?.mapResultCount }}
    </button>
  </div>
</div>
